export const faqs = [
  {
    q: "明察爆料主要收录哪些类型的爆料？",
    a: "我们聚焦损害公共利益的骗局与乱象，目前分为金融骗局、网络诈骗、消费维权、行业黑幕、职场陷阱五类。所有内容都以「事件、机构、套路」为对象，帮助读者识别风险、提前避坑。"
  },
  {
    q: "平台会公开某个具体个人的身份信息吗？",
    a: "不会。我们不收集、不整理、不公开任何自然人的身份信息，也不提供任何形式的寻人或人肉线索征集。凡涉及披露个人隐私的投稿，一律不予采用。"
  },
  {
    q: "我想投稿一条爆料，需要提供什么？",
    a: "尽量提供事件经过、涉及的主体名称、时间线与已有的凭证说明即可。请务必隐去无关个人的姓名、电话和住址。你也可以通过页面底部的投稿表单提交线索，我们会人工查看。"
  },
  {
    q: "你们如何保证爆料内容的真实性？",
    a: "每条案例发布前都会进行多来源交叉核对，无法核实的关键情节会在文中明确标注为「待核实」。我们更倾向于呈现可复现的套路规律，而不是未经证实的指控。"
  },
  {
    q: "被曝光的主体可以申请更正吗？",
    a: "可以。如果你认为内容存在事实错误，可通过投稿表单提交说明与佐证材料，我们会在核对后对确有错误的部分进行更正或补充说明，并标注更新时间。"
  },
  {
    q: "内容可以转载吗？",
    a: "欢迎在注明来源并保留原文链接的前提下转载用于非商业用途。商业使用请先通过投稿表单与我们取得联系。"
  },
  {
    q: "网站上的案例会涉及具体公司名称吗？",
    a: "为降低误伤风险，我们在案例中通常使用「某类平台」「某品牌门店」等概括性表述，重点还原套路本身。这样既能让读者看懂规律，也避免对具体主体造成未经核实的负面指向。"
  },
  {
    q: "发现新骗局想提醒更多人，最快的办法是什么？",
    a: "通过投稿表单提交，简要写清套路步骤和识别要点即可。如果你希望让身边人尽快知道，也可以直接把尚未发布的案例链接或我们的防骗指南转发给家人朋友。"
  }
];

export const brand = {
  name: "明察爆料",
  slogan: "曝光骗局，守护真相",
  intro:
    "明察爆料是一个面向普通网民的公共利益爆料与避坑资讯平台。我们把网友的真实踩坑经历整理成可读、可检索、可参考的爆料档案，帮你在遇到类似套路时更快识别、更早止损。",
  positioning:
    "我们不追逐猎奇，也不针对个人。我们关注的始终是那些反复出现、有规律可循的骗局与乱象，让经验可以被复制，让套路无处遁形。",
  email: "tips@mingcha-baoliao.com",
  workTime: "工作日 09:30 - 18:30",
  replyTime: "投稿与更正常在 3 个工作日内回复",
  domain: "https://shhziying.cn",
  principles: [
    {
      title: "只对套路，不对个人",
      desc: "所有内容以事件、机构与手法为对象，坚决不涉及自然人的身份信息与隐私线索。"
    },
    {
      title: "可核实，才发布",
      desc: "关键情节经过多来源交叉核对，无法证实的部分明确标注，不制造未经核实的指控。"
    },
    {
      title: "写给普通人看",
      desc: "拒绝术语堆砌，用口语化的方式还原经过，让每个人都能读懂、用得上。"
    },
    {
      title: "错了就改",
      desc: "收到有效更正材料后及时复核修正，并公开标注更新时间，接受读者监督。"
    }
  ],
  stats: [
    { value: "1,286", label: "已收录爆料案例" },
    { value: "312", label: "防骗指南与拆解" },
    { value: "86 万+", label: "累计访问人次" },
    { value: "97%", label: "读者认为有帮助" }
  ],
  testimonials: [
    {
      name: "陈女士",
      role: "广州 · 企业职员",
      quote:
        "刷到那篇刷单返利的复盘时，我表妹正好在做类似兼职。文章里的步骤几乎一模一样，我们当晚就让她退出了。"
    },
    {
      name: "李先生",
      role: "成都 · 个体经营者",
      quote:
        "办健身卡之前顺手查了下主体，发现门店一直在换营业执照，果断只办了月卡。两个月后那家店就关门了。"
    },
    {
      name: "王同学",
      role: "武汉 · 应届毕业生",
      quote:
        "培训贷那篇写得很清楚，面试时对方让我签分期协议，我当场就拒绝了，不然现在还在还贷款。"
    },
    {
      name: "周阿姨",
      role: "杭州 · 退休教师",
      quote:
        "女儿把家庭防骗那篇发给我，我们约好大额消费先打电话商量。上个月有人拉我去听讲座，我留了个心眼没买。"
    }
  ]
};

export const navItems = [
  { label: "首页", path: "/" },
  { label: "爆料广场", path: "/expose" },
  { label: "防骗指南", path: "/guides" },
  { label: "关于我们", path: "/about" },
  { label: "常见问题", path: "/faq" }
];